// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PreloadImage extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Image) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__PreloadImage"] = this;

    /* START-USER-CTR-CODE */
    this.scene.load.on(Phaser.Loader.Events.PROGRESS, (p: number) => {
      let percent = this.gameObject.width * p;

      if (this.reverseDirection) this.gameObject.setCrop(0, 0, percent, this.gameObject.height);
      else this.gameObject.setCrop(percent, 0, this.gameObject.width, this.gameObject.height);
    });
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Image): PreloadImage {
    return (gameObject as any)["__PreloadImage"];
  }

  private gameObject: Phaser.GameObjects.Image;
  public reverseDirection: boolean = false;

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
